import React from 'react';
import { DollarSign, Hash, CreditCard } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function TesoreriaParametrizacion() {
    const items = [
        { title: 'Cajas y Terminales', icon: Hash, href: '/parametrizacion/cajas', color: 'bg-yellow-500' },
        { title: 'Formas de Pago/Cobro', icon: CreditCard, href: '/parametrizacion/formas-pago', color: 'bg-blue-500' },
        { title: 'Monedas', icon: DollarSign, href: '/parametrizacion/monedas', color: 'bg-yellow-600' },
    ];

    return (
        <div className="p-6">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="px-6 py-4 flex items-center space-x-4 bg-yellow-100 text-yellow-800">
                    <DollarSign className="w-8 h-8 opacity-80" />
                    <div>
                        <h3 className="text-xl font-bold">3. Módulo: Tesorería y Pagos</h3>
                        <p className="text-sm opacity-90">Configuración operativa de las sucursales y ventanillas.</p>
                    </div>
                </div>

                <div className="p-6">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                        {items.map((table, idx) => (
                            <Link
                                key={idx}
                                to={table.href}
                                className="bg-gray-50 text-gray-800 border-gray-100 hover:bg-opacity-90 p-4 rounded-xl shadow-sm hover:shadow-md transition-all border flex flex-col items-center text-center group"
                            >
                                <div className={`p-3 rounded-full ${table.color} bg-opacity-10 mb-3 group-hover:scale-110 transition-transform`}>
                                    <table.icon className={`w-6 h-6 ${table.color.replace('bg-', 'text-')}`} />
                                </div>
                                <h4 className="font-bold text-sm text-gray-800 group-hover:text-blue-600 transition-colors leading-tight">{table.title}</h4>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
